<template>
  <v-btn
    class="mt-3 text-subtitle-1 font-weight-bold"
    block
    color="#315ED9"
    dark
    type="submit"
    @submit.prevent="login"
    >{{ label }}</v-btn
  >
</template>

<script>
export default {
  name: 'LoginButton',
  props: {
    label: {
      type: String,
      required: true
    }
  },
  methods: {
    login () {
      this.$emit('login')
    }
  }
}
</script>

<style></style>
